import CollectionApi from 'client/api/v2/CollectionApi';

class SoftwareApi extends CollectionApi {
  constructor() {
    super('/api/v2/software', {
      skip: 0,
      limit: 10,
    });
  }

  fetchOsReleases(parameters) {
    return this.axios.get(`${this.baseUrl}/catalog?${parameters.osName.length ? `filter=operatingSystem:search:${parameters.osName}&limit=${parameters.limit}` : ''}&sort=${parameters.sort || ''}`);
  }

  fetchOsReleasesForWidget(parameters) {
    return this.axios.get(`${this.baseUrl}/catalog?${parameters.osName.length ? `filter[1]=operatingSystem:search:${parameters.osName}&filter[0]=releaseTimestamp:gt:${parameters.date}&limit=${parameters.limit}` : ''}&sort=${parameters.sort || ''}`)
      .then(resp => ({
        results: resp.data,
        totalCount: +resp.headers['x-total-count'],
      }));
  }
}

export default new SoftwareApi();
